import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
import { colors, getResetByTag, utilityStyles, rem } from './../../styles';
var defaultStyles = function defaultStyles() {
  return /*#__PURE__*/css("border:", rem(1), " solid ", colors.coolGray_300, ";border-radius:", rem(1), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultStyles;"));
};
var variantStyles = function variantStyles(_ref3) {
  var variant = _ref3.variant;
  switch (variant) {
    case 'cool-gray':
    case 'gray':
      return /*#__PURE__*/css("background-color:", colors.coolGray_200, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:variantStyles;"));
    case 'dark':
      return /*#__PURE__*/css("background-color:", colors.navy_500, ";border-color:", colors.navy_400, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:variantStyles;"));
    default:
      return /*#__PURE__*/css("background-color:", colors.white, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:variantStyles;"));
  }
};
var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "1e1ncky",
  styles: "border:none"
} : {
  name: "1pwvne6-hasBorderStyles",
  styles: "border:none;label:hasBorderStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var hasBorderStyles = function hasBorderStyles(_ref4) {
  var hasBorder = _ref4.hasBorder;
  if (hasBorder === false) {
    return _ref2;
  }
};
var _ref = process.env.NODE_ENV === "production" ? {
  name: "1hcx8jb",
  styles: "padding:0"
} : {
  name: "5scmoy-densityStyles",
  styles: "padding:0;label:densityStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var densityStyles = function densityStyles(_ref5) {
  var density = _ref5.density;
  switch (density) {
    case 'compact':
      return /*#__PURE__*/css("padding:", rem(8, 16), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:densityStyles;"));
    case 'flush':
      return _ref;
    default:
      return /*#__PURE__*/css("padding:", rem(16), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:densityStyles;"));
  }
};
var resetStyles = getResetByTag('div');
var StyledBox = /*#__PURE__*/_styled('div', process.env.NODE_ENV === "production" ? {
  target: "eow4j4x0"
} : {
  target: "eow4j4x0",
  label: "StyledBox"
})(resetStyles, defaultStyles, variantStyles, densityStyles, hasBorderStyles, utilityStyles);
export default StyledBox;